import type { GovPaginationProps } from '@gov-design-system-ce/react';
import { GovPagination } from '@gov-design-system-ce/react';
import { useBreakpoints } from '@gov-nx/utils/web';

export const Pagination = ({ onPage, ...props }: GovPaginationProps) => {
	const { isSm } = useBreakpoints();

	return (
		<GovPagination
			{...props}
			onPage={onPage}
			type={isSm ? 'select' : props.type}
		/>
	);
};
